export default __webpack_public_path__ + "static/media/pic2.2c21a722.jpg";